import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postTaricSearch } from '../api/taric';
import AddCommodityCodeModal from './AddCommodityCodeModal';

const TaricTool = () => {
  const [input, setInput] = useState('');
  const [results, setResults] = useState([]);
  const [error, setError] = useState('');
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setInput(value);
      setError('');
    } else {
      setInput(value);
      setError('Please enter numbers only.');
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setSearched(true);
    setLoading(true);
    setError('');

    if (!input || !/^\d+$/.test(input)) {
      setResults([]);
      setError('Please enter a valid numeric code.');
      setLoading(false);
      return;
    }

    try {
      const response = await postTaricSearch(input);
      setResults(response);
      setError(response.length === 0 ? 'No results found.' : '');
    } catch (err) {
      setError('Failed to search. Please try again.');
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleResultClick = (code) => {
    navigate(`/taric/${code}`);
  };

  const handleAddClick = () => {
    setShowAddModal(true);
  };

  const handleAddSuccess = () => {
    if (input) {
      handleSearch({ preventDefault: () => {} });
    }
  };

  return (
    <div className="full-width-container">
      <section className="floating-box position-relative" style={{ maxWidth: '500px' }}>
        <h1 className="floating-box-header-newload">
          <span>Taric Tool</span>
        </h1>
        <form onSubmit={handleSearch} style={{ padding: '16px 32px', marginBottom: '0', minHeight: '220px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
            <label htmlFor="taric-code" style={{ marginBottom: 0, minWidth: 120 }}>
              Commodity Code
            </label>
            <input
              id="taric-code"
              type="text"
              value={input}
              onChange={handleInputChange}
              className="form-control"
              autoComplete="off"
              style={{ flex: 1, minWidth: 0 }}
              disabled={loading}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
            <button
              type="submit"
              className="blue-button-teams"
              style={{ minWidth: 100 }}
              disabled={loading || !input.trim() || input.length < 1}
            >
              {loading ? 'Searching...' : 'Find Now'}
            </button>
          </div>
          <div style={{ borderTop: '2px solid #ccc', marginLeft: '-32px', marginRight: '-32px' }} />
          <div style={{ padding: '16px', minHeight: '200px' }}>
            {error && <p style={{ color: 'red', fontWeight: 500, margin: '0 0 8px 0' }}>{error}</p>}
            {loading && <p style={{ color: '#666', fontWeight: 500, margin: '0 0 8px 0' }}>Searching...</p>}
            {searched && !loading && results.length > 0 ? (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Commodity Code</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleResultClick(item.code || item.commodityCode || item.commCode);
                          }}
                          style={{ color: '#0d6efd', textDecoration: 'underline', cursor: 'pointer' }}
                        >
                          {item.code || item.commodityCode || item.commCode}
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : searched && !loading && results.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <p style={{ color: '#666', fontWeight: 500, margin: '0 0 16px 0' }}>No results found.</p>
                <button className="blue-button-teams" type="button" onClick={handleAddClick} style={{ minWidth: 100 }}>
                  ADD
                </button>
              </div>
            ) : null}
          </div>
          <div style={{ borderTop: '2px solid #ccc', marginLeft: '-32px', marginRight: '-32px' }} />
          <div
            style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 20, height: 70, alignItems: 'center' }}
          >
            <button
              type="button"
              className="blue-button-teams green-btn"
              onClick={() => {
                setInput('');
                setResults([]);
                setError('');
                setSearched(false);
              }}
              style={{ minWidth: 100, height: 40 }}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
        </form>
      </section>
      <AddCommodityCodeModal show={showAddModal} onHide={() => setShowAddModal(false)} onSuccess={handleAddSuccess} />
    </div>
  );
};

export default TaricTool;
